import { ConfigStore } from '@estee/elc-service';
import { IAppConfig } from '@estee/elc-universal-utils';

export interface IPaymentDetails {
    provider: string;
    publicKey: string;
    accountId: string;
    sandboxMode: boolean;
}

type UnknownObject = { [key: string]: unknown };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class DrupalConfigStore extends ConfigStore<any> {}

type DrupalPropsToCast<T = string | number> = {
    sessionExpiredStartTime?: T;
    sessionExpiredTimeout?: T;
    costLimit?: T;
    maxQuantity?: T;
    threeInstallmentsLimit?: T;
    sixInstallmentsLimit?: T;
};

export type DrupalProps = {
    routes: UnknownObject;
    services: UnknownObject;
    cdnPath: string;
    defaultDomain: string;
    clientId: string;
} & DrupalPropsToCast &
    IAppConfig &
    UnknownObject;

export type CastedDrupalProps = {
    routes: UnknownObject;
    services: UnknownObject;
    cdnPath: string;
    defaultDomain: string;
    clientId: string;
} & DrupalPropsToCast<number> &
    IAppConfig &
    UnknownObject;

export const mapConfigToProps = (drupalProps: DrupalProps): CastedDrupalProps => {
    const castDrupalPropToNumber = (key: string): number | undefined => {
        const drupalProp = drupalProps[key] as string | number;

        return typeof drupalProp === 'string' ? Number(drupalProp) : drupalProp;
    };

    const sessionExpiredStartTime = castDrupalPropToNumber('sessionExpiredStartTime');
    const sessionExpiredTimeout = castDrupalPropToNumber('sessionExpiredTimeout');
    const costLimit = castDrupalPropToNumber('costLimit');
    const maxQuantity = castDrupalPropToNumber('maxQuantity');
    const threeInstallmentsLimit = castDrupalPropToNumber('threeInstallmentsLimit');
    const sixInstallmentsLimit = castDrupalPropToNumber('sixInstallmentsLimit');
    const baseUrl = drupalProps.defaultDomain;

    return {
        ...drupalProps,
        sessionExpiredStartTime,
        sessionExpiredTimeout,
        costLimit,
        maxQuantity,
        threeInstallmentsLimit,
        sixInstallmentsLimit,
        baseUrl
    };
};
